var map = {
	"./de/general7/slide3.svg": 156910,
	"./en/general7/slide3.svg": 367394,
	"./es/general7/slide3.svg": 581835,
	"./fr/general7/slide3.svg": 704099,
	"./nl/general7/slide3.svg": 171301,
	"./pt/general7/slide3.svg": 736455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 439832;